import React from 'react'

import { Typography, Grid, Container } from '@the-platform-group/component-library'

import PeopleMergeFlow from './components/people/MergeFlow'
import PageHeader from 'components/Layout/PageHeader'

const MergeProfiles = ({ mergeType = 'people' }) => {
  return (
    <Grid container direction="column" spacing={3}>
      <PageHeader
        title={mergeType === 'people' ? 'People Merge' : 'Organization Merge'}
        subtitle="Please ensure all data is correct and up-to-date. If any FactSet data requires updating please raise an RPD."
      />
      <Grid item container>
        <Container maxWidth="xl" disableGutters>
          {mergeType === 'people' ? (
            <PeopleMergeFlow />
          ) : (
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Typography variant="body1" color="text.secondary">
                  TODO:Organization merge
                </Typography>
              </Grid>
            </Grid>
          )}
        </Container>
      </Grid>
    </Grid>
  )
}

export default MergeProfiles
